import { useRef } from "react";
import useOnClickOutside from "../../../hooks/click-outside.hook";
import c from "../FilterDropdown.module.scss";
import { Transition } from "react-transition-group";
import { animationClassHandler } from "../../../helper/common.helper";
import { cn } from "../../../lib/utils";
import ListFilter from "./ListFilter";
import { FilterProvider, useFilterContext } from "./context";

const classNames = {
	toggle:
		"border border-dark-30 text-dark-70 inline-flex pt-[6px] pb-[5px] px-5 rounded-full cursor-pointer select-none gap-3 hover:border-dark-100 hover:text-dark-100 font-semibold text-14 items-center",
	toggleOpen: "border-interactive-100 shadow-[0_4px_8px] shadow-dark-100/10 bg-interactive-10",
	toggleLoading: "bg-dark-10 text-dark-50 shadow-none",
	counterContainer:
		"w-5 h-5 bg-interactive-100 rounded-full flex items-center justify-center text-center",
	counter: "text-11 leading-[10px] font-medium text-white",
	popover:
		"absolute overflow-hidden border border-dark-10 shadow-[0_8px_20px] shadow-dark-100/10 rounded-[10px] bg-white mt-4 min-w-[300px] flex flex-col z-10",
};

const Filter = ({ children, ...props }) => {
	return (
		<FilterProvider>
			<FilterContent {...props}>{children}</FilterContent>
		</FilterProvider>
	);
};

const FilterContent = ({ isLoading, children, counter, label, customToggle, className }) => {
	const { isOpen, setIsOpen } = useFilterContext();
	const popoverContainer = useRef(null);

	const popoverContent = useRef(null);

	useOnClickOutside(popoverContainer, () => setIsOpen(false));

	return (
		<div ref={popoverContainer} className={cn("relative", isLoading && c.loading)}>
			<button
				type="button"
				className={className.button}
				onClick={() => !isLoading && setIsOpen(!isOpen)}
			>
				{customToggle ? (
					typeof customToggle === "function" ? (
						customToggle({ isOpen })
					) : (
						customToggle
					)
				) : (
					<div
						className={cn(
							classNames.toggle,
							isOpen && classNames.toggleOpen,
							isLoading && classNames.toggleLoading
						)}
					>
						<span>{label}</span>

						{counter > 0 && (
							<div className={classNames.counterContainer}>
								<span className={classNames.counter}>{counter}</span>
							</div>
						)}
						{isLoading && (
							<div className="flex">
								<span className="icon_16 default loader icon_mask !bg-dark-70"></span>
							</div>
						)}
					</div>
				)}
			</button>

			<Transition
				nodeRef={popoverContent}
				in={isOpen}
				mountOnEnter
				unmountOnExit
				timeout={{ enter: 200, exit: 200 }}
			>
				{(state) => (
					<div
						ref={popoverContent}
						className={cn(
							classNames.popover,
							animationClassHandler(state, "popover_in", "popover_out"),
							className.popover
						)}
					>
						{children}
					</div>
				)}
			</Transition>
		</div>
	);
};

Filter.List = ListFilter;

export default Filter;
